// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobDetails_root__0YqZ6 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
}
.JobDetails_root__0YqZ6 section {
  color: #111111;
  overflow: hidden;
}
.JobDetails_root__0YqZ6 section .JobDetails_alert__EQJbE {
  justify-content: center;
}
.JobDetails_root__0YqZ6 section header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
}
.JobDetails_root__0YqZ6 section header .JobDetails_title__O7hq7 {
  font-size: 16px;
}
.JobDetails_root__0YqZ6 section .JobDetails_field__A3gZ7 {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  line-height: 34px;
}
.JobDetails_root__0YqZ6 section .JobDetails_field__A3gZ7 .JobDetails_label__69b5c {
  color: rgba(17, 17, 17, 0.568627451);
}
.JobDetails_root__0YqZ6 section .JobDetails_field__A3gZ7 .JobDetails_value__pPoBr {
  display: flex;
  gap: 2px;
  align-items: center;
}
.JobDetails_root__0YqZ6 section .JobDetails_field__A3gZ7 .JobDetails_value__pPoBr .JobDetails_view3d__-uWam {
  display: flex;
  align-items: center;
  opacity: 0.54;
  font-size: 12px;
  color: rgba(17, 17, 17, 0.84);
}
.JobDetails_root__0YqZ6 .JobDetails_aspects__mugTO {
  padding-bottom: 32px;
}
.JobDetails_root__0YqZ6 .JobDetails_aspects__mugTO .nav-tabs {
  padding: 10px 16px 0;
}
.JobDetails_root__0YqZ6 .JobDetails_aspects__mugTO .JobDetails_goc__E-3tZ .JobDetails_gocFields__eFfKI {
  display: flex;
  gap: 32px;
  padding: 28px;
}
.JobDetails_root__0YqZ6 .JobDetails_title__O7hq7 {
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 300;
  color: #111111;
}
.JobDetails_root__0YqZ6 .nav-link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/JobDetails/JobDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACF;AAAE;EACE,cAAA;EACA,gBAAA;AAEJ;AADI;EACE,uBAAA;AAGN;AADI;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;AAGN;AAFM;EACE,eAAA;AAIR;AADI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AAGN;AAFM;EACE,oCAAA;AAIR;AAFM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAIR;AAHQ;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;AAKV;AACE;EACE,oBAAA;AACJ;AAAI;EACE,oBAAA;AAEN;AACM;EACE,aAAA;EACA,SAAA;EACA,aAAA;AACR;AAIE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,eAAA;AAHJ","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-top: 16px;\r\n  margin-bottom: 32px;\r\n  section {\r\n    color: #111111;\r\n    overflow: hidden;\r\n    .alert {\r\n      justify-content: center;\r\n    }\r\n    header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      border-bottom: 1px solid #dedede;\r\n      .title {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n    .field {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      font-size: 15px;\r\n      line-height: 34px;\r\n      .label {\r\n        color: #11111191;\r\n      }\r\n      .value {\r\n        display: flex;\r\n        gap: 2px;\r\n        align-items: center;\r\n        .view3d {\r\n          display: flex;\r\n          align-items: center;\r\n          opacity: 0.54;\r\n          font-size: 12px;\r\n          color: rgba(17, 17, 17, 0.84);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .aspects {\r\n    padding-bottom: 32px;\r\n    :global(.nav-tabs) {\r\n      padding: 10px 16px 0;\r\n    }\r\n    .goc {\r\n      .gocFields {\r\n        display: flex;\r\n        gap: 32px;\r\n        padding: 28px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .title {\r\n    padding: 16px 24px;\r\n    font-size: 20px;\r\n    font-weight: 300;\r\n    color: #111111;\r\n  }\r\n\r\n  :global(.nav-link) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JobDetails_root__0YqZ6`,
	"alert": `JobDetails_alert__EQJbE`,
	"title": `JobDetails_title__O7hq7`,
	"field": `JobDetails_field__A3gZ7`,
	"label": `JobDetails_label__69b5c`,
	"value": `JobDetails_value__pPoBr`,
	"view3d": `JobDetails_view3d__-uWam`,
	"aspects": `JobDetails_aspects__mugTO`,
	"goc": `JobDetails_goc__E-3tZ`,
	"gocFields": `JobDetails_gocFields__eFfKI`
};
export default ___CSS_LOADER_EXPORT___;
